import gql from 'graphql-tag';

export default gql`
  query getEssensysInfoForInvoice($invoiceId: String!, $companyId: UUID) {
    essensys {
      invoicePdfUrl(invoiceId: $invoiceId, companyId: $companyId)
    }
  }
`;
